module.exports = "https://r.zoocdn.com/_next/static/images/second-stepper-couple-88edf867168c4cdaa926ff3e8eb9e8e6.png";